import { useContext } from 'react';

import { PersonContactStateContext } from './PersonContactContextProvider';

import PersonContactData from './PersonContactData';

const usePersonContactData = () => {
  const [personContactState, setPersonContactState] = useContext(PersonContactStateContext);

  const getPersonContact = (personId) => {
    return PersonContactData.getPersonContact(personId, personContactState, setPersonContactState);
  };

  const updatePersonContact = (personId, contactData) => {
    return PersonContactData.updatePersonContact(personId, contactData, personContactState, setPersonContactState);
  };

  const confirmPersonContact = (personId) => {
    return PersonContactData.confirmPersonContact(personId, personContactState, setPersonContactState);
  };

  const clearPersonContactObjData = () => {
    setPersonContactState({ ...PersonContactData.INITIAL_STATE });
  };

  return {
    personContactState,
    getPersonContact,
    updatePersonContact,
    confirmPersonContact,
    clearPersonContactObjData
  };
};

export default usePersonContactData;